// extracted by mini-css-extract-plugin
export default {"waveform":"waveform--2H-WX","buttonSecondary":"buttonSecondary--QUCNS","waveformButton":"waveformButton--rQ8OF","active":"active--3YXc_"};